
  import { defineComponent } from 'vue';

  import constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import AnalyticsNotesTemplate from '../components/analytics-notes/AnalyticsNotesTemplate.vue';
  import { TAnalyticsNotesFilter } from '../types/analytics-notes';
  import { CostTypes, TreeCountryValues } from '../types/common-aggregated';
  import { TAggregatedPermissions } from '../types/permission';

  const DEFAULT_FILTER: Omit<TAnalyticsNotesFilter, 'selectType'> = {
    periods: ['2012-M2'],
    country: [TreeCountryValues.GERMANY_99],
    costType: CostTypes.BILLIONS_OF_DOLLARS,
  };

  export default defineComponent({
    name: 'AnalyticsNotesMonthly',
    components: { AnalyticsNotesTemplate },
    mixins: [security],
    data(): { defaultFilter: TAnalyticsNotesFilter; pageTitle: string } {
      return {
        defaultFilter: { ...DEFAULT_FILTER },
        pageTitle: 'Аналитическая записка по внешней торговле РФ по странам мира (месячная)',
      };
    },
    mounted() {
      this.checkPermissionAndRedirect(this.getPermissions.view);
    },
    computed: {
      getPermissions(): TAggregatedPermissions {
        return {
          view: constants.Permissions.ForeignTradeAnalyticsWorldMonthlyNoteView,
          build: constants.Permissions.ForeignTradeAnalyticsWorldMonthlyNoteBuild,
          export: constants.Permissions.ForeignTradeAnalyticsWorldMonthlyNoteDownload,
        };
      },
    },
  });
